import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import {OverlayTrigger, Tooltip, Popover} from "react-bootstrap";
import toastr from "toastr";
import Constants from "../../classes/constants";

function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
    return rowIdx % 2 == 0 ? 'color' : 'td-column-function-odd-example';
}

class JobDetailsTable extends React.Component {

  constructor() {
    super();
  }

  navigate(url){
       let win = window.open();
       win.document.write('<iframe src="' + url  + '"frameborder="0" style="border:0; top:0px; left:0px; bottom:0px;' +
                ' right:0px; width:103%; height:100%;" allowfullscreen>Download</iframe>');
     }


  render() {
    return (
      <div>
        <BootstrapTable
        data={this.props.jobs}>
          <TableHead
            isKey={false}
            hidden={false}
            columnClassName="leftRightOnlyZero"
            width={50}
            dataFormat={(cell, row)=> {
              return <div>
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Remove</Tooltip>}>
                  <img style={{cursor: 'pointer'}}
                       onClick={()=> {
                         let flag = confirm("Are you sure?")
                         if (flag == true) {
                           this.props.edit(row);
                         }
                       }}
                       src="/public/images/error.png"></img>
                </OverlayTrigger>
              </div>

            }}
            dataField="id"> </TableHead>
            <TableHead dataField="id"
            isKey={true}
            filter={ {type: 'TextFilter', delay: 0,  placeholder: 'Id'} }
            dataFormat={(cell, row)=> {
              return <OverlayTrigger trigger={['hover']} placement="top">
                <u><a onClick={()=>{this.navigate(Constants.tejaUrl+row.jobLink)}}>{cell}</a></u>
              </OverlayTrigger>
            }}
            dataSort={true}
            columnClassName={ columnClassNameFormat }
            width={60}>Id</TableHead>
          <TableHead dataField="departmentName"
                     filter={ {type: 'TextFilter', delay: 0,  placeholder: 'Department'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     width={160}>Department</TableHead>

          <TableHead dataField="jobTitle"
                               filter={ {type: 'TextFilter', delay: 0, placeholder: 'Job Title'} }
                               dataFormat={this.checkNull}
                               dataSort={true}
                               columnClassName={ columnClassNameFormat }
                               width={140}>Job Title</TableHead>
          <TableHead dataField="jobPostTime"
                                         dataFormat={(cell)=> {
                                                                if (cell != null && cell != 'NA' && cell != 0)
                                                                  return <font >{new Date(cell).toDateString()}</font>
                                                                else
                                                                  return 'NA';
                                                              }}
                                         dataSort={true}
                                         columnClassName={ columnClassNameFormat }
                                         width={120}>Date</TableHead>

        </BootstrapTable>

      </div>
    );
  }
}

JobDetailsTable.propTypes = {};

export default JobDetailsTable;





/** WEBPACK FOOTER **
 ** ./src/components/Referral/JobDetailsTable.js
 **/